import React from 'react'
import { _defineHelpUrlandToolTip } from '../helpers/index.js'

const ColourPicker = function () {
    const name = "colour_picker";
    ColourPicker.blockName = name;

    _defineHelpUrlandToolTip(name,  Blockly.BASE_HELP_URL + "#colours");

    return <block type={name}></block>;
}

export default ColourPicker;